import type { IConfigurationGroup } from "App/Modules/Models";
import { ConfigurationGroupTypeFunctions } from "App/Modules/Models";

export function SortConfigurationGroupsByType() {
    return (groups: IConfigurationGroup[], $translate: ng.translate.ITranslateService) => {
        return ConfigurationGroupTypeFunctions.sortConfigurationGroupsByType(groups, $translate);
    };
}
